module.exports = __webpack_public_path__ + "img/6_7.fedf3f13.png";